// extracted by mini-css-extract-plugin
export default {"colorLegendSquare":"DailyAvailability_colorLegendSquare__q3FnQ"};